import { Play, Save } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { replayWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  replayWeb,
  {
    ReplayPage: () => import('./ReplayPage'),
    ReplaysPage: () => import('./ReplaysPage'),
    ReplayEditorPage: () => import('./ReplayEditorPage'),
    LiveReplayPage: () => import('./LiveReplayPage'),
    SaveAsReplayDialog: () => import('./SaveAsReplayDialog'),
  },
  {
    icons: { Play, Save },
  },
);
